import formatDate from 'src/utils/commonMethods/formatDate'

const INSURANCE_DETAILS = {
  POLICY_COVERAGES: 'Policy Coverages',
  DOWNLOAD_POLICY_DOCUMENT: 'Download Policy Document',
  HELP_LINE_24: '24/7 Help line',
  HELP_MOBILE: '1800 3099 247',
  SUPPORT_EMAIL: 'support@trovity.com',
  ASSET_TYPE: 'ASSET',
  ANNEXURE_ADD_ANNEXURE_IN_3_EASY_STEPS: 'Add Annexure in 3 easy Steps',
  ANNEXURE_DOWNLOAD_THE_FORMAT: 'Download the format',
  ANNEXURE_ADD_DETAILS_AS_PER_THE_FORMAT: 'Add details as per the format',
  ANNEXURE_UPLOAD_THE_EXCEL: 'upload the excel',
  ANNEXURE_DEPENDANT: 'Dependant',
  UPLOAD_ANNEXURE: 'Upload Annexure',
  UPLOAD_ASSET: 'Upload Asset',
  ANNEXURE_DOWNLOAD: 'Download',
  FILTER: 'Filter',
  LOCATIONS: 'Locations',
  APPLY: 'Apply',
  NO_DATA_FOR_THE_SELECTED_CRITERIA: 'No data for the selected criteria',
  REQUEST_AN_ENDORSEMENT: 'Request an Endorsement',
  REQUEST_APPROVED: 'Request Approved',
  REQUEST_SUBMITTED: 'Request Submitted',
  IN_PROGRESS: 'In Progress',
  ADDITIONAL_INFORMATION_REQUIRED: 'Additional Information Required',
  REQUEST_REJECTED: 'Request Rejected',
  REQUEST_INITIATED: 'Request Initiated',
  NEED_APPROVAL: 'Need Approval',
}

const VIEW_INSTALLMENT_COLUMNS = [
  { label: 'Installment No', field: 'installmentNo' },
  { label: 'Date', field: 'installmentDate', format: formatDate },
  { label: 'Amount (₹)', field: 'installmentAmount' },
]

export { INSURANCE_DETAILS, VIEW_INSTALLMENT_COLUMNS }
